import React, { useEffect, useMemo, useState } from "react";
import { useAuth } from "../auth/AuthContext";

import DailyListTable from "../components/DailyListTable";
import ModalItem from "../components/ModalItem";
import { useNotification } from "../components/NotificationContext";
import useWsEvents from "../hooks/useWsEvents";
import { buildProcessedMeters, getItemChanges, normalizeItemDateForApi } from "../utils/items";
import { isSameAmsterdamDay } from "../utils/time";
import {
    createDailyList,
    getCorrectOrder,
    getDailyList,
    getDailyListMetadata,
    getVoorraad,
    setProp,
    updateDailyListNode,
} from "../api/wsApi";

function DailyList() {
    const [data, setData] = useState({});
    const [correctOrder, setCorrectOrder] = useState([]);
    const [voorraad, setVoorraad] = useState({ stock: {}, created: null });
    const auth = useAuth();

    const [selectedItem, setSelectedItem] = useState(null);
    const [showModal, setShowModal] = useState(false);

    const notification = useNotification();

    useEffect(() => {
        fetchCorrectOrder();
        fetchDailyList();
        fetchVoorraadData();

        fetchDailyListMetaData()
            .then((metaData) => {
                if (!isSameAmsterdamDay(metaData.created)) {
                    createNewDailyList().then(() => {
                        fetchCorrectOrder();
                        fetchDailyList();
                    });
                } else {
                    fetchCorrectOrder();
                    fetchDailyList();
                }
            })
            .catch((err) => {
                console.log("Error fetching daily list metadata", err);
                //fetchDailyListMetaData();
            });
    }, []);

    const processedData = useMemo(() => buildProcessedMeters(correctOrder, data), [correctOrder, data]);

    const createNewDailyList = async () => {
        return createDailyList()
            .then(() => {
                console.log("New daily list created");
            })
            .catch((err) => {
                console.log("Error creating new daily list", err);
            });
    };

    const fetchCorrectOrder = async () => {
        getCorrectOrder()
            .then((data) => {
                setCorrectOrder(data);
            })
            .catch((err) => {
                console.log("Error fetching correct order", err);
            });
    };

    const fetchDailyList = async () => {
        getDailyList()
            .then((data) => {
                const sortedData = {};
                data.forEach((element) => {
                    sortedData[element.id] = element;
                });
                setData(sortedData);
            })
            .catch((err) => {
                console.log("Error fetching daily list", err);
                notification("Error fetching daily list", "error");
                //fetchDailyList();
            });
    };

    const newDate = (id, date, recursivecout = 0) => {
        const normalizedDate = normalizeItemDateForApi(date);

        updateDailyListNode(id, normalizedDate)
            .then(() => {
                fetchDailyList();
            })
            .catch((err) => {
                console.log("Error updating date", err);

                if (recursivecout < 3) {
                    recursivecout++;
                    setTimeout(() => {
                        newDate(id, date, recursivecout);
                    }, 1000);
                } else {
                    console.log("Error updating date", err);
                    notification("Error updating date", "error");
                }
            });
    };

    const fetchDailyListMetaData = async () => {
        return getDailyListMetadata()
            .then((data) => {
                //console.log("metaData", data)
                return data;
            })
            .catch((err) => {
                console.log("Error fetching daily list metadata", err);
                //return fetchDailyListMetaData();
            });
    };

    const fetchVoorraadData = async () => {
        getVoorraad()
            .then((data) => {
                setVoorraad(data);
            })
            .catch((err) => {
                console.log("Error fetching voorraad", err);
            });
    };

    useWsEvents((message) => {
        switch (message.event) {
            case "dailyListUpdated":
                fetchDailyList();
                break;
            case "correctOrderUpdated":
                fetchCorrectOrder();
                break;
            case "voorraadUpdated":
                fetchVoorraadData();
                break;
            default:
                break;
        }
    });

    const openBeheer = (id) => {
        setSelectedItem(data[id]);
        setShowModal(true);
    };

    useEffect(() => {
        if (selectedItem && data[selectedItem.id]) setSelectedItem(data[selectedItem.id]);
    }, [data]);

    const quickAction = (id, action) => {
        alert("Quick action does not work yet");
    };

    const updateDataItem = (item) => {
        const originalItem = data[item.id];
        const changes = getItemChanges(item, originalItem);
        changes.forEach(({ key, value }) => {
            setProp(key, item.id, value)
                .then(() => {
                    fetchDailyList();
                    notification("Item updated", "success");
                })
                .catch((err) => {
                    console.log("Error updating item", err);
                    notification("Error updating item", "error");
                });
        });
    };

    const applyDailyList = () => {
        console.log("Apply daily list is not available.");
    };

    useEffect(() => {
        const tmp = setTimeout(() => {
            if (document.getElementById("apply")) {
                document.getElementById("apply").style.display = "none";
            }
        }, 1000);
        return () => clearTimeout(tmp);
    }, []);

    return (
        <div>
            <ul>
                {processedData && (
                    <DailyListTable
                        meters={processedData}
                        openBeheer={openBeheer}
                        quickAction={quickAction}
                        newDate={newDate}
                        voorraad={voorraad["stock"] ? voorraad["stock"] : {}}
                    />
                )}
            </ul>

            {showModal && (
                <ModalItem
                    item={selectedItem}
                    onClick={() => {
                        setShowModal(false);
                    }}
                    updateDataItem={updateDataItem}
                    fetchData={fetchDailyList}
                />
            )}

            {auth.isAdmin() && processedData && (
                <div className="divWrap">
                    <button
                        id="apply"
                        onClick={() => {
                            applyDailyList();
                        }}
                        style={{
                            display: "none",
                        }}
                    >
                        Apply
                    </button>
                </div>
            )}

            {voorraad.created && <p>Voorraad van {voorraad.created}</p>}
        </div>
    );
}

export default DailyList;
